/* eslint-disable react-hooks/exhaustive-deps */
import { Loader, Nav, Sidebar, Sidenav } from "rsuite";
import FolderFill from "@rsuite/icons/FolderFill";
import { Offcanvas, OffcanvasHeader } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { MenuState, useStore } from "../../context/AppContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-regular-svg-icons";
import { ModuloPermiso } from "../../types/admin-usuarios/ModuloPermiso";
import ArrowRightIcon from "@rsuite/icons/ArrowRight";
import MinusIcon from "@rsuite/icons/Minus";
import isMobile from "is-mobile";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

export default function Sidemenu({
  expand,
  setExpand,
}: {
  expand: boolean;
  setExpand: any;
}) {
  const [menuAn, setMenuAn] = useState<ModuloPermiso[]>([]);
  const [activeKey, setActiveKey] = useState("/");
  const [openKeys, setOpenKeys] = useState<string[]>([]);
  let location = useLocation();
  const { state } = useStore();

  useEffect(() => {
    setActiveKey(location.pathname);
  }, [location]);

  useEffect(() => {
    if (state.menu.loaded && state.menu.modulos) {
      anidarModulos();
    }
  }, [state.menu.loaded]);

  function anidarModulos() {
    const cpModulos = [...(state.menu.modulos?.slice() || [])];
    cpModulos.forEach((m: ModuloPermiso) => {
      if (m.parent) {
        const moduloPadre = cpModulos.find(
          (mp: ModuloPermiso) => mp._id === m.parent
        );
        if (moduloPadre) {
          //comprueba que no sea indefinido
          if (moduloPadre.children === undefined) moduloPadre.children = [];
          moduloPadre.children.push(m);
        } else {
          delete m.parent;
        }
      }
    });
    const clnMod = cpModulos.filter((m: ModuloPermiso) => !m.parent);
    setMenuAn(clnMod);
  }

  if (!state.user.authenticated) return null;

  return (
    <>
      {isMobile() ? (
        <Offcanvas
          show={expand}
          onHide={() => setExpand(false)}
          backdropClassName="d-md-none"
          className="d-md-none"
          style={{ maxWidth: "80%" }}
        >
          <OffcanvasHeader closeButton>
            <div className="d-flex flex-row overflow-x-visible justify-content-center">
              <img
                src="/images/logo.png"
                width="25"
                className="me-2"
                alt="app-logo"
              />
              <h6 className="title">
                Sistema de búsqueda de sentencias y jurisprudencia
              </h6>
            </div>
          </OffcanvasHeader>
          <Menu
            expand={expand}
            state={state.menu}
            menuAn={menuAn}
            arKeys={[openKeys, setOpenKeys, activeKey]}
          />
        </Offcanvas>
      ) : (
        <Sidebar
          className="d-flex flex-column shadow d-none d-md-block sidemenu"
          collapsible
          width={expand ? 260 : 56}
        >
          <Sidenav.Header className="header bg-primary">
            <div
              className={`d-flex flex-row overflow-x-visible justify-content-${
                expand ? "center" : "start"
              }`}
              style={{ height:expand? "104px":"" }}
            >
             
              {expand && (
                <h4 className="d-none d-sm-block title ms-1 text-white align-self-center align-content-center">
                  Plataforma de
                  <br />
                  Gestión Documental
                </h4>
              )}
            </div>
          </Sidenav.Header>
          <Menu
            expand={expand}
            state={state.menu}
            menuAn={menuAn}
            arKeys={[openKeys, setOpenKeys, activeKey]}
          />
        </Sidebar>
      )}
    </>
  );
}

function Menu({
  expand,
  state,
  menuAn,
  arKeys,
}: {
  expand: boolean;
  state: MenuState;
  menuAn: ModuloPermiso[];
  arKeys: [string[], any, string];
}) {
  return (
    <Sidenav
      className="body position-relative bg-z"
      expanded={expand}
      openKeys={arKeys[0]}
      onOpenChange={(ok:  (string | number)[]) => arKeys[1](ok.slice(ok.length - 1))}    
    >
      <Sidenav.Body className="bg-darks">
        {state.loaded && state.modulos && state.modulos.length > 0 ? (
          <Nav activeKey={arKeys[2]} className="bg-darks">
            <Nav.Item
              as={Link}
              to="/"
              icon={<FolderFill />}
              eventKey="/"
              className="bg-darks"
            >
              Administrador Archivos
            </Nav.Item>
            {menuAn.map((m: ModuloPermiso, ix: number) => (
              <RecursiveMenu module={m} key={"mr" + m.route + ix} />
            ))}
          </Nav>
        ) : (
          <Nav>
            <div className="text-center mt-2">
              <FontAwesomeIcon icon={faBell as IconProp} shake size="2x" />
              <p>No hay modulos para este perfil</p>
            </div>
          </Nav>
        )}
        {state.loading && <Loader backdrop center style={{ zIndex: 10 }} />}
      </Sidenav.Body>
    </Sidenav>
  );
}

function RecursiveMenu({ module }: { module: ModuloPermiso }) {
  function getIcon() {
    return module.children ? <ArrowRightIcon /> : <MinusIcon />;
  }
  return module.children ? (
    <Nav.Menu
      eventKey={module.route}
      title={module.name}
      icon={getIcon()}
      placement="rightStart"
    >
      {module.children.map((mc: ModuloPermiso, ix: number) => (
        <RecursiveMenu module={mc} key={"mm" + mc.route + ix} />
      ))}
    </Nav.Menu>
  ) : (
    <Nav.Item
      className="bg-darks"
      as={Link}
      to={module.route}
      icon={getIcon()}
      key={"mi" + module.route}
      eventKey={module.route}
    >
      {module.name}
    </Nav.Item>
  );
}

// const modules = [
//     { route: "/usuarios", name: "Usuarios", ico: <ShieldIcon /> },
//     { route: "/modulos", name: "Modulos", ico: <ShieldIcon /> },
//     { route: "/perfiles", name: "Perfiles", ico: <ShieldIcon /> },
//     { route: "/perfiles-modulos", name: "Perfiles Módulos", ico: <ShieldIcon /> },
//     { route: "/sistemas", name: "Sistemas", ico: <ShieldIcon /> },
//     {
//         route: "/usuarios-perfiles",
//         name: "Usuario Perfiles",
//         ico: <ShieldIcon />,
//     },
//     { route: "/auth", ico: <ShieldIcon />, name: "Login" },
// ];
